import React, { useContext } from 'react';
import { SystemContext } from '../contexts/SystemContext';
import Sanity from '../services/Sanity';
import MODES from '../types/Modes';
import Button from './common/Button';
var TopBar = function () {
    var _a = useContext(SystemContext), mode = _a.mode, setMode = _a.setMode, onFocus = _a.onFocus, selecting = _a.selecting;
    return (React.createElement("div", { className: "flex justify-between pb-2" },
        React.createElement("div", { className: "pl-2" },
            React.createElement(Button, { color: "gray", onClick: function () { return Sanity.syncer.syncAllVideosWithSanity(); } }, "Sync with Vimeo"),
            mode === MODES.BROWSING ?
                React.createElement(Button, { color: "green", onClick: function () { return setMode(MODES.UPLOADING); } }, "Upload")
                : React.createElement(Button, { color: "green", onClick: function () { return setMode(MODES.BROWSING); } }, "Browse")),
        React.createElement("div", null, selecting && React.createElement(Button, { onClick: onFocus }, "Close"))));
};
export default TopBar;
